export default __webpack_public_path__ + "locales/es/CreateEditRoomDialog.json?hash=b784c88cd1c03ceaf1a9225c94a07f2a";